import { useState, useEffect } from 'react';

/**
 * Hook to detect mobile screens (< 768px).
 * Returns true on mobile, false on desktop.
 * Updates on window resize.
 */
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    let timeout;
    const handleResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        setIsMobile(window.innerWidth < breakpoint);
      }, 150); // debounce
    };

    window.addEventListener('resize', handleResize);
    // Initial check
    setIsMobile(window.innerWidth < breakpoint);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
